import { MOVE_CLICK_THRESHOLD_PX } from '@/components/app/editor/selection-chrome/selection-chrome-constants'

/**
 * True once a move's pointer delta (canvas units) is far enough to be a drag rather than a click.
 * The inverse of the click test `handlePointerUp` applies, so a gesture is never both.
 */
export function isPastMoveClickThreshold(dx: number, dy: number): boolean {
  return Math.abs(dx) >= MOVE_CLICK_THRESHOLD_PX || Math.abs(dy) >= MOVE_CLICK_THRESHOLD_PX
}
